import irelandApi from '../irelandApi';

const getEligibilities = () => (dispatch) => {
  dispatch({ type: 'GET_ELIGIBILITIES_PENDING', payload: [] });
  return irelandApi.get('/api/admin/objectives/eligibilities')
    .then((response) => {
      dispatch({
        type: 'GET_ELIGIBILITIES_FULFILLED',
        payload: response.data.eligibilities
      });
    })
    .catch((error) => {
      dispatch({
        type: 'GET_ELIGIBILITIES_REJECTED',
        payload: error.response
      });
      return Promise.reject(error.response.data.errors);
    });
};

export default getEligibilities;
